import React from 'react'
import NavBar from './components/NavBar'
import './App.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import PlaybackPage from './screens/PlaybackPage'
import Entitlements from './screens/Entitlements'
import ProtectedRoute from './customroute/ProtectedRoute'
import LoginPageRoute from './customroute/LoginPageRoute'
import LoginPage from './screens/LoginPage'
import Footer from './components/Footer'
import DynPage from "./screens/DynPage";
import UploadScreen from "./screens/UploadScreen";
import NotificationManager from './components/NotificationManager';

function App() {
    return (
        <div className="App" style={myStyle.container}>
            <NavBar/>
            <NotificationManager />
            <div id="app-container">
                <BrowserRouter>
                    <Routes>
                        <Route path='/login' element={<LoginPageRoute><LoginPage/></LoginPageRoute>}/>
                        <Route path='/playback' element={<ProtectedRoute><PlaybackPage/></ProtectedRoute>}/>
                        <Route path='/upload' element={<UploadScreen/>}/>
                        <Route path='/' element={<ProtectedRoute><Entitlements/></ProtectedRoute>}/>
                        {/*<Route path='/dynpath' element={<DynPage/>}/>*/}
                    </Routes>
                </BrowserRouter>
            </div>
            <Footer/>
        </div>
    );
}

const myStyle = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start'
    }
}

export default App;
